import React, { useContext } from 'react';
import IdleTimer from 'react-idle-timer'
import { useCountdownTimer } from 'use-countdown-timer';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import StudentContext from '../../../context/student-context';

const IdleTimeOutModal = () => {
    const { countdown, start, reset } = useCountdownTimer({ timer: 60000 });
    const [idleTimer, setIdleTimer] = React.useState({});
    const [idleTimeOut, setIdleTimeOut] = React.useState(false);
    const [decisionMaking, setDecisonMaking] = React.useState(null);
    const { logout } = useContext(StudentContext);

    const onIdle = () => {
        setIdleTimeOut(true);
        start();

        setDecisonMaking(setTimeout(() => {
            handleLogout();
        },
            60000));
    }

    const handleClose = () => {
        clearTimeout(decisionMaking);
        reset();
        setIdleTimeOut(false);
    };

    const handleLogout = async () => await logout();

    return (
        <div>
            <IdleTimer
                ref={ref => setIdleTimer(ref)}
                onIdle={onIdle}
                debounce={250}
                timeout={15 * 60 * 1000} />

            <Dialog
                open={idleTimeOut}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title" className="idletimeoutmodal__dialog__title">
                    <div className="adventurelearn__header">You Have Been Idle!</div>
                </DialogTitle>
                <DialogContent>

                    <div className="adventurelearn__subheader" style={{ margin: 10, }}>You Have Been Idle! You will get Time Out. Do you want to stay?</div>

                    <div style={{ color: '#ff5768', textAlign: "center", fontSize: '1.2rem' }}>
                        {countdown / 1000}s</div>

                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} className="adventurelearn__dialogOk">
                        Stay
                    </Button>
                    <Button onClick={handleLogout} className="adventurelearn__dialogCancel">
                        Logout
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export { IdleTimeOutModal as default }